import useTranslation from '@/utils/hooks/translation/useTranslation';

// Types
import type { DatepickerComparisonPeriodsAvailableType } from '@/lib/periods';
// Lib
import { dataCompareTo } from '@/lib/periods';

import Dropdown, { BaseItem } from '@/components/base/Dropdown';
// Components
import Icon from '@/components/base/Icon';
import { TabItem } from '@/components/composite/PeriodPicker/components/PeriodTabs/TabItem';

type CompareToTabProps = {
    onChange: (arg: DatepickerComparisonPeriodsAvailableType) => void;
    compareTo: DatepickerComparisonPeriodsAvailableType;
};

export function CompareToTab({ onChange, compareTo }: CompareToTabProps) {
    const { t } = useTranslation();

    return (
        <div className="flex items-center">
            <span className="ml-1 mr-2 h-5 w-0.5 bg-icoGray-300 dark:bg-icoDarkMode-beton" />
            <Dropdown
                size="custom"
                position="left"
                button={
                    <Dropdown.Button data-testid="button-compare-to" as={TabItem}>
                        <span>{t('commons:datepicker.compare_to')}</span>
                        <Icon
                            icon="chevron-bottom"
                            className="text-xs text-icoGray-400 dark:text-icoDarkMode-wolf"
                        />
                    </Dropdown.Button>
                }>
                <div className="w-full space-y-0.5 overflow-hidden rounded-md p-0.5">
                    {dataCompareTo.map((item) => {
                        const isActive = compareTo === item.value;
                        return (
                            <Dropdown.Item key={item.value} className="">
                                <BaseItem
                                    as="button"
                                    data-testid={`button-compare-to-${item.value}${
                                        isActive ? '-active' : ''
                                    }`}
                                    onClick={() => onChange(item.value)}
                                    active={isActive}
                                    className="whitespace-nowrap focus:ring-0 focus:ring-offset-0">
                                    {t(item.label)}
                                </BaseItem>
                            </Dropdown.Item>
                        );
                    })}
                </div>
            </Dropdown>
        </div>
    );
}
